/**
 * OnboardingWorkspaceStep Component
 * First step: Create a workspace
 */

import { useState } from 'react'
import { toast } from 'sonner'
import { WorkspaceForm } from '@/components/workspaces/WorkspaceForm'
import { WorkspaceFormValues } from '@/lib/validations/workspace'
import { workspaceService } from '@/services'
import { useAuth } from '@/hooks/useAuth'
import { useOnboarding } from '@/contexts/OnboardingContext.context'

interface OnboardingWorkspaceStepProps {
  onSkip: () => void
  skipLabel?: string
}

export function OnboardingWorkspaceStep({ onSkip }: OnboardingWorkspaceStepProps) {
  const { user } = useAuth()
  const { setWorkspaceId, setWorkspaceName, nextStep } = useOnboarding()
  const [isLoading, setIsLoading] = useState(false)
  const [logo, setLogo] = useState<string | undefined>()

  const onSubmit = async (data: WorkspaceFormValues) => {
    if (!user) {
      toast.error('You must be logged in to create a workspace')
      return
    }

    setIsLoading(true)
    try {
      const workspace = await workspaceService.createWorkspace(
        {
          ...data,
          logo,
        },
        user.id
      )

      setWorkspaceId(workspace.id)
      setWorkspaceName(data.name)
      toast.success('Workspace created successfully!')
      nextStep()
    } catch (error) {
      console.error('Failed to create workspace:', error)
      toast.error('Failed to create workspace')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <WorkspaceForm
      defaultValues={{
        name: '',
        email: user?.email || '',
      }}
      currentUser={user}
      logo={logo}
      onLogoChange={setLogo}
      currentUsers={[]}
      usersToAdd={[]}
      usersToRemove={[]}
      availableUsers={[]}
      onAddUser={() => {}}
      onRemoveUserToAdd={() => {}}
      onSubmit={onSubmit}
      onCancel={onSkip}
      submitText={isLoading ? 'Creating Workspace...' : 'Create Workspace & Continue'}
      cancelText="Skip Workspace Creation"
      loading={isLoading}
      title="Create Your First Workspace"
      description="A workspace is where you'll organize all your projects and tasks"
      simplified={true}
    />
  )
}
